export default __webpack_public_path__ + "static/media/Boots of Vernant Fury.664a9e29.jpg";